import { useEffect } from 'react'

import { useParams } from 'react-router-dom'
import { getDetailedInfo } from 'store/OVContext/ovSlice'
import { useDispatch, useSelector } from 'store/store'

import { BillingSection } from './components/BillingSection'
import { CancelSection } from './components/CancelSection'
import { CommercialSection } from './components/CommercialSection'
import { CostElementSection } from './components/CostElementSection'
import { PartnersSection } from './components/PartnersSection'
import { TrackingSection } from './components/TrackingSection'
import * as S from './styles'

const GeneralInfoTab = () => {
  const dispatch = useDispatch()
  const { ovNumber } = useParams()
  const {
    ovSelected: { statusOrdemVenda: status },
  } = useSelector((state) => state.ov)
  const { isSampleOrder } = useSelector((state) => state.salesOrder)

  const isCanceled = status?.split('-')[0] === '90'

  useEffect(() => {
    dispatch(getDetailedInfo(ovNumber ?? ''))
  }, [ovNumber])

  return (
    <S.Wrapper>
      <div className="commercial">
        <CommercialSection />
      </div>
      <BillingSection />
      <TrackingSection />
      {isCanceled ? (
        <>
          <div className="partners">
            <PartnersSection />
          </div>
          <div className="cancel">
            <CancelSection />
          </div>
        </>
      ) : (
        <div className="partners-full">
          <PartnersSection />
        </div>
      )}
      {isSampleOrder && (
        <div className="cost">
          <CostElementSection />
        </div>
      )}
    </S.Wrapper>
  )
}

export default GeneralInfoTab
